export default __webpack_public_path__ + "static/media/B671.c68b01ef.webp";